import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import "./popover.script";
export function RuiPopoverContent({
  children,
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("div", {
    ...props,
    class: cx(className),
    children
  });
}
export function RuiPopover({
  trigger,
  children,
  variant = "default",
  ...props
}) {
  const variantClass = variant === "listbox" ? "rui-popover--listbox" : "";
  return /* @__PURE__ */jsx("rui-popover", {
    ...props,
    variant,
    children: /* @__PURE__ */jsxs("div", {
      class: "rui-popover-host",
      "data-ref": "host",
      children: [trigger != null ? /* @__PURE__ */jsx("span", {
        "data-popover-trigger": true,
        children: trigger
      }) : null, /* @__PURE__ */jsx("div", {
        "data-ref": "surface",
        class: `rui-popover rui-floating ${variantClass}`.trim(),
        role: "dialog",
        children
      })]
    })
  });
}
export function RuiPopoverTrigger({
  trigger,
  children,
  ...props
}) {
  return /* @__PURE__ */jsx("rui-popover-trigger", {
    ...props,
    children: /* @__PURE__ */jsxs("div", {
      class: "rui-popover-trigger",
      "data-ref": "root",
      children: [/* @__PURE__ */jsx("span", {
        "data-popover-trigger": true,
        children: trigger
      }), children]
    })
  });
}